"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebView = void 0;
function isWebView() {
    if (typeof window !== "undefined") {
        const userAgent = window.navigator.userAgent || window.navigator.vendor;
        // Check for Android WebView
        const androidWebView = /wv|.0.0.0/.test(userAgent) && /Android/.test(userAgent);
        // Check for iOS WebView
        const iosWebView = /iPhone|iPod|iPad/.test(userAgent) && !/Safari/.test(userAgent);
        // Additional check for standalone mode
        const standalone = window.navigator.standalone;
        return androidWebView || iosWebView || standalone;
    }
}
exports.isWebView = isWebView;
//# sourceMappingURL=is-web-view.js.map